import { create } from "zustand";
import { persist } from "zustand/middleware";
import { customStorage } from "../utils/index";

import {
  setLogout,
  signUpUser,
  getUsersList,
  loginUserUtils,
  verifyCodeUtils,
  resetPasswordUtils,
  forgotPasswordUtils,
  resendVerifyCodeUtils,
} from "../utils/authUtils";

const useUserStore = create()(
  persist(
    (set) => ({
      token: "",
      user: null,
      hasHydrated: false,
      isVerify: false,
      isVerifyLoading: false,
      subscription_status: null,
      isLoading: false,
      isSignUp: false,
      isForgotPassword: false,
      email: "",
      list: [],
      pagination: { limit: 10, page: 1, totalCount: 0, totalPages: 0 },

      // Setters for modifying state

      setUser: (user) => set({ user }),
      setToken: (token) => set({ token }),
      setHasHydrated: (hasHydrated) => set({ hasHydrated }),
      setEmail: (email) => set({ email }),
      setIsLoading: (isLoading) => set({ isLoading }),
      setIsSignUp: (isSignUp) => set({ isSignUp }),
      setIsSubscription: (subscription) =>
        set({ subscription_status: subscription }),
      setIsForgotPassword: (isForgotPassword) => set({ isForgotPassword }),
      updateUser: (updatedUserData) =>
        set((state) => {
          const updatedList = state.list.map((user) =>
            user._id === updatedUserData._id
              ? { ...user, ...updatedUserData }
              : user
          );
          return { list: updatedList };
        }),
      // Async actions that modify state
      loginUser: async (payload, navigate) => {
        await loginUserUtils(payload, navigate, set); // Call the utility function and pass `set` to update state
      },
      registerUser: async (payload) => {
        await signUpUser(payload, set); // Call the utility function and pass `set` to update state
      },
      fetchUsers: async (payload) => {
        await getUsersList(payload, set); // Call the utility function and pass `set` to update state
      },
      verifyCode: async (payload) => {
        await verifyCodeUtils({ ...payload, set });
      },
      resendVerifyCode: async (payload) => {
        await resendVerifyCodeUtils({ ...payload, set });
      },
      forgotPassword: async (payload) => {
        await forgotPasswordUtils({ ...payload, set });
      },
      resetPassword: async (payload) => {
        await resetPasswordUtils({ ...payload, set });
      },
      setUserLogout: () => {
        setLogout(set);
      },
    }),
    {
      name: "user-storage", // Store name for persistence (localStorage)
      storage: customStorage, // Use custom localStorage (or sessionStorage)
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);

export default useUserStore;
